import React from 'react'
import { Box, Button, Typography } from '@mui/material'

/** Minimal error UI kept in the main bundle (no large SVG assets). */
const SimpleErrorFallback: React.FC<{ error?: Error }> = ({ error }) => {
  return (
    <Box
      sx={{
        minHeight: '50vh',
        display: 'grid',
        placeItems: 'center',
        px: 2,
        textAlign: 'center',
        gap: 2,
      }}>
      <Typography variant="h5" component="h1">
        Something went wrong
      </Typography>
      {error?.message && (
        <Typography variant="body2" color="text.secondary">
          {error.message}
        </Typography>
      )}
      <Button variant="contained" color="secondary" href="/">
        Go home
      </Button>
    </Box>
  )
}

export default SimpleErrorFallback
